import React, { useState } from 'react';
import { List, Button, Input, Space, message, Popconfirm, Form } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { createAccountType, updateAccountType, deleteAccountType } from '../services/api';

const AccountTypeManager = ({ accountTypes, onRefresh }) => {
  const [editingId, setEditingId] = useState(null);
  const [editingName, setEditingName] = useState('');
  const [newTypeName, setNewTypeName] = useState('');
  const [loading, setLoading] = useState(false);

  const handleAdd = async () => {
    if (!newTypeName.trim()) {
      message.error('请输入类型名称');
      return;
    }
    setLoading(true);
    try {
      await createAccountType({ name: newTypeName.trim() });
      message.success('添加成功');
      setNewTypeName('');
      onRefresh();
    } catch (error) {
      message.error(error.message || '添加失败');
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (id, currentName) => {
    setEditingId(id);
    setEditingName(currentName);
  };

  const handleSave = async (id) => {
    if (!editingName.trim()) {
      message.error('请输入类型名称');
      return;
    }
    setLoading(true);
    try {
      await updateAccountType(id, { name: editingName.trim() });
      message.success('修改成功');
      setEditingId(null);
      setEditingName('');
      onRefresh();
    } catch (error) {
      message.error(error.message || '修改失败');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    setLoading(true);
    try {
      await deleteAccountType(id);
      message.success('删除成功');
      onRefresh();
    } catch (error) {
      message.error(error.message || '删除失败');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setEditingId(null);
    setEditingName('');
  };

  return (
    <div>
      {/* 添加新类型 */}
      <Space.Compact style={{ width: '100%', marginBottom: 16 }}>
        <Input
          placeholder="输入新的账号类型"
          value={newTypeName}
          onChange={(e) => setNewTypeName(e.target.value)}
          onPressEnter={handleAdd}
        />
        <Button 
          type="primary" 
          icon={<PlusOutlined />} 
          onClick={handleAdd}
          loading={loading}
        >
          添加
        </Button>
      </Space.Compact>

      {/* 类型列表 */}
      <List
        dataSource={accountTypes}
        renderItem={(item) => (
          <List.Item
            actions={[
              editingId === item.id ? (
                <Space key="edit">
                  <Button 
                    size="small" 
                    type="primary" 
                    onClick={() => handleSave(item.id)}
                    loading={loading}
                  >
                    保存
                  </Button>
                  <Button 
                    size="small" 
                    onClick={handleCancel}
                  >
                    取消
                  </Button>
                </Space>
              ) : (
                <Button 
                  key="edit"
                  size="small" 
                  icon={<EditOutlined />} 
                  onClick={() => handleEdit(item.id, item.name)}
                >
                  编辑
                </Button>
              ),
              <Popconfirm
                key="delete"
                title="确定删除这个类型吗？"
                onConfirm={() => handleDelete(item.id)}
                okText="确定"
                cancelText="取消"
              >
                <Button 
                  size="small" 
                  danger 
                  icon={<DeleteOutlined />}
                  loading={loading}
                >
                  删除
                </Button>
              </Popconfirm>
            ]}
          >
            {editingId === item.id ? (
              <Input
                value={editingName}
                onChange={(e) => setEditingName(e.target.value)}
                onPressEnter={() => handleSave(item.id)}
                autoFocus
              />
            ) : (
              <span>{item.name}</span>
            )}
          </List.Item>
        )}
      />
    </div>
  );
};

export default AccountTypeManager;
